import { useEffect, useMemo, useState } from "react";
import {
	Edit,
	FileField,
	FileInput,
	useUpdate,
	TextInput,
	SimpleForm,
	useNotify,
	useRedirect,
	useRefresh,
	useTranslate,
	useGetList,
	SelectInput,
} from "react-admin";

import userPreferences from "../../utils/fakeUserPrefrences";
import { transformToFormData } from "../../utils/customFunctions";
import { validateContentData } from "./hrResourcesContentValidate";
import { CustomToolbar } from "../../customComponents/CustomToolbar";

export const HRResourcesContentEdit = (props) => {
	const [resourcesCategoriesChoices, setResourcesCategoriesChoices] =
		useState([]);

	const { data: resourcesCategoriesData } = useGetList(
		"hr/resources/categories"
	);
	const [update] = useUpdate("hr/resources/content", props.id);
	const { data: languagesData } = useGetList("languages");
	const translate = useTranslate();
	const redirect = useRedirect();
	const refresh = useRefresh();
	const notify = useNotify();

	const defaultLocale = useMemo(
		() => userPreferences.defaultTranslationLanguage,
		[]
	);

	const onSuccess = () => {
		notify(translate("hr.resources.content.edit.success"), "info");
		redirect("/hr/resources/content");
		refresh();
	};

	const onFailure = (error) => {
		notify(error.message, "warning");
	};

	useEffect(() => {
		resourcesCategoriesChoices.length <= 0 &&
			setResourcesCategoriesChoices(
				Object.values(resourcesCategoriesData).map(
					({ id, titles }) => ({
						id,
						name:
							titles?.[defaultLocale] ||
							titles[userPreferences.translationLanguages[0]] ||
							titles[userPreferences.translationLanguages[1]],
					})
				)
			);
	}, [resourcesCategoriesChoices]);

	return (
		<Edit {...props} title={translate("hr.resources.content.edit.title")}>
			<SimpleForm
				save={(data) => {
					const transformed = transformToFormData(data);
					update(
						{ payload: { data: transformed.formData } },
						{
							onSuccess,
							onFailure,
						}
					);
				}}
				toolbar={<CustomToolbar />}
				validate={validateContentData}
				syncWithLocation={false}
			>
				<TextInput source="name" />
				<SelectInput
					label="category"
					source="categoryId"
					choices={resourcesCategoriesChoices}
				/>
				<FileInput
					source="content"
					label="Resources Content"
					placeholder={translate(
						"hr.resources.content.edit.uploadContentPlaceholder"
					)}
				>
					<FileField title="rowFile.name" source="src" />
				</FileInput>
			</SimpleForm>
		</Edit>
	);
};
